import { Routes, Route } from 'react-router-dom';

import CertificatesView from './list';

const CertificatesRouter = () => {
    return (
        <Routes>
            <Route path='/' element={<CertificatesView />}></Route>
        </Routes>
    )
}

export default CertificatesRouter;